import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalSettings } from '../../hooks/useGlobalSettings';
import { useAvatar } from '../../hooks/useAvatar';
import { useScreensaverData } from '../../hooks/pages/useScreensaverData';
import Animation from '../common/Animation';
import AnimatedWordsMarkdown from '../common/AnimatedWordsMarkdown';

export default function QuizScreensaver({ station, theme }) {
  const navigate = useNavigate();
  const { data: pageData, error: pageDataError } = useScreensaverData(station);
  const { globalSettings, error: globalSettingsError } = useGlobalSettings();
  const { avatarData, error: avatarDataError } = useAvatar('Bildschirmschoner');

  useEffect(() => {
    const handler = () => navigate('/quiz/startseite');
    window.addEventListener('keydown', handler);
    window.addEventListener('click', handler);
    window.addEventListener('pointerdown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
      window.removeEventListener('click', handler);
      window.removeEventListener('pointerdown', handler);
    };
  }, [navigate]);

  if (globalSettingsError || pageDataError || avatarDataError) {
    return <div>Fehler: {globalSettingsError || pageDataError || avatarDataError}</div>;
  }

  if (!globalSettings || !pageData || !avatarData) {
    return <div>Laden...</div>;
  }

  const { text } = pageData;
  const { logoUrl } = globalSettings;
  const avatar = avatarData[0]?.animation;

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      <div className="flex h-screen">
        <div className="flex-1 md:w-1/3 flex flex-col items-start justify-start relative">
          <img src={logoUrl} alt="Logo" className="absolute top-16 left-16 h-16" />
          <div className="absolute bottom-0 transform -translate-x-64">
            <Animation src={avatar} className={'object-contain portrait:h-full portrait:w-auto landscape:min-w-fit'} />
          </div>
        </div>
        <div
          className="flex flex-2 flex-col justify-center md:w-1/2 rounded-br-[150px] rounded-tl-[150px] px-12 py-20 mr-48 ml-8 my-28"
          style={{ backgroundColor: theme.screensaverForegroundColor }}
        >
          <AnimatedWordsMarkdown text={text} className={'text-5xl'} />
        </div>
      </div>
    </div>
  );
}